import { useMemo, useState } from 'react';
import { dedupeTagsFromProducts } from '../utils/productCatalogTags';
import { rankProductsByTags } from '../utils/rankProductsByTags';

export function useProductTagFilter(products = []) {
  const [tagFilter, setTagFilter] = useState([]);

  const catalogTags = useMemo(() => dedupeTagsFromProducts(products), [products]);
  const filteredProducts = useMemo(
    () => rankProductsByTags(products, tagFilter),
    [products, tagFilter]
  );

  return { tagFilter, setTagFilter, catalogTags, filteredProducts };
}
